"use client"

import React from "react"

import SubNav from "@/ui/patterns/SubNav"

const PaymentsLayout: React.FC<any> = ({ children }) => {
  const parentLink = "Ripple Payments"

  const menuLinks = [
    {
      text: "Product Overview",
      location: "/solutions/cross-border-payments/",
    },
    {
      text: "Payout Network",
      location: "/solutions/cross-border-payments/payout-network/",
    },
  ]

  return (
    <div className="bg-white-100">
      <SubNav menuLinks={menuLinks} parentLink={parentLink} mode="light" />
      {children}
    </div>
  )
}

export default PaymentsLayout
